import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueLazyload from 'vue-lazyload'
import {VueMasonryPlugin} from 'vue-masonry'
import VueHead from 'vue-head'


Vue.use(VueMasonryPlugin)

import './assets/styles.scss'

// import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'

Vue.config.productionTip = false

Vue.use(VueLazyload, {
  loading: 'https://ekran.werled.ru/wp-content/uploads/2019/11/preloader.gif',
  error: undefined
})

Vue.use(VueHead, {
  separator: '',
  complement: ''
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
